import Axios from 'axios'

// constant
import * as types from '../types'
import { host } from '../../../../host'

// helper
import catchErrorApi from '../../../../helper/catchErrorApi'
import genGetRequest from '../../../../helper/genGetRequest'
import autoDownloadFromBlob from '../../../../helper/autoDownloadFromBlob'

const apiGetListTimeServicesOfTellerByServices = `${host}admin/exportJSON/averageTellerTimeByService`
const apiExportListTimeServicesOfTellerByServices = `${host}admin/export/averageTellerTimeByService`

export const getListTimeServicesOfTellerByServices = ({
    FromDate,
    ToDate,
    BranchIDs,
    ServiceCode,
    TellerUserName,
    ReportCodeName,
    BranchName,
}) => async (dispatch) => {
    const dataRequest = JSON.stringify({
        FromDate,
        ToDate,
        BranchIDs,
        ServiceCode,
        TellerUserName,
        ReportCodeName,
        BranchName,
    })

    try {
        const res = await Axios.post(
            apiGetListTimeServicesOfTellerByServices,
            dataRequest
        )
        const { data } = res
        dispatch({
            type: types.GET_LIST_TIME_SERVICES_OF_TELLER_BY_TRANS,
            payload: {
                condFilter: {
                    FromDate,
                    ToDate,
                    BranchIDs,
                    ServiceCode,
                    TellerUserName,
                    ReportCodeName,
                    BranchName,
                },
                listData: data.Data || [],
            },
        })
    } catch (err) {
        catchErrorApi(
            err,
            dispatch,
            types.GET_LIST_TIME_SERVICES_OF_TELLER_BY_TRANS_ERROR,
            () => false
        )
    }
}

export const exportListTimeServicesOfTellerByServices = ({
    FromDate,
    ToDate,
    BranchIDs,
    ServiceCode,
    TellerUserName,
    ReportCodeName,
    BranchName,
    BranchCodes,
}) => async (dispatch) => {
    if (!BranchCodes) return

    const dataRequest = JSON.stringify({
        FromDate,
        ToDate,
        BranchIDs,
        ServiceCode,
        TellerUserName,
        ExportExcel: true,
        ReportCodeName,
        BranchName,
    })

    try {
        const res = await Axios.post(
            apiGetListTimeServicesOfTellerByServices,
            dataRequest,
            {
                responseType: 'blob',
            }
        )
        const { data } = res
        if (BranchCodes.length === 1) {
            autoDownloadFromBlob(
                data,
                TellerUserName
                    ? `${ReportCodeName}-${BranchCodes[0]}-${TellerUserName}`
                    : `${ReportCodeName}-${BranchCodes[0]}-ALL`
            )
        } else {
            autoDownloadFromBlob(
                data,
                TellerUserName
                    ? `${ReportCodeName}-${BranchCodes.join(
                        '-'
                    )}-${TellerUserName}`
                    : `${ReportCodeName}-${BranchCodes.join('-')}-ALL`
            )
        }
    } catch (err) {
        console.log(err)
    }
}
